/**
 * Renders a read-only view of the attributes of a group as well as an interface for adding users to and removing users from the group.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Group` model associated with the view.
 * @module app/views/admin/groups/Details
 */
import Backbone from "backbone";
import _ from "underscore";
import OrganizationCollection from "app/models/OrganizationCollection";
import Field from "core/models/Field";
import User from "app/models/User";
import $ from "jquery";
import UserCollection from "app/models/UserCollection";
import AddRemove from "app/views/admin/users/AddRemove";
import ValueCollections from "app/models/ValueCollections";
import ErrorUtils from "app/utils/ErrorUtils";
import messenger from "app/Messenger";
import _remove from "lodash.remove";
export default Backbone.View.extend({
  className: "group-details",
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Group} options.model The model to display.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
    this._users = new UserCollection([]);
    this._organizations = new OrganizationCollection([]);
    this._loaded = new $.Deferred();
    this._userFields = [];
    this._currentUsers = [];

    var self = this;

    this._users.fetch({
      success: function () {
        self._organizations.fetch({
          success: function () {
            self.model.getUsers(function (err, users) {
              if (err) {
                return self._loaded.reject(err);
              }

              self._currentUsers = _.pluck(users.models, "id");
              self._userFields = [
                new Field(User.fields["Username"]).decorate({
                  name: "id",
                  id: "id",
                  viewOptions: {
                    type: "link",
                    linkField: "Username",
                    linkUrl: "user",
                  },
                  sortable: "Username",
                  filterable: "Username",
                }),
                new Field(User.fields["Name"]),
                new Field({
                  id: "Organization",
                  label: "Organization",
                  name: "Organization",
                  valueSource: ValueCollections.Organization,
                }),
                new Field(User.fields["EmailAddress"]),
              ];
              self._loaded.resolve();
            });
          },
          error: function (collection, response) {
            self._loaded.reject(response);
          },
        });
      },
      error: function (collection, response) {
        self._loaded.reject(response);
      },
    });
  },

  _removeUser: function (userId) {
    var self = this;

    this.model
      .removeUser(userId)
      .done(function () {
        messenger.success("User removed.");
        _remove(self._currentUsers, userId);
      })
      .fail(
        ErrorUtils.errorHandler({
          activity: "removing the user",
        })
      );
  },

  _addUser: function (userId) {
    var self = this;

    this.model
      .addUser(userId)
      .done(function () {
        messenger.success("User added.");
        self._currentUsers.push(userId);
      })
      .fail(
        ErrorUtils.errorHandler({
          activity: "adding the user",
        })
      );
  },

  template: _.template(
    '<h1><%- model.get("name")%></h1><div class="table-container"></div>'
  ),

  render: function () {
    this.$el.html(this.template(this.options));
    var self = this;

    this._loaded
      .done(function () {
        var tableView = new AddRemove({
          users: self._users,
          fields: self._userFields,
          decider: function (user) {
            return _.contains(self._currentUsers, user.id);
          },
          inTabName: "Group Users",
          outTabName: "Other Users",
        });

        tableView.render();
        tableView.on(
          "add",
          function (user) {
            this._addUser(user.id);
          },
          self
        );
        tableView.on(
          "remove",
          function (user) {
            this._removeUser(user.id);
          },
          self
        );
        tableView.$el.appendTo(self.$(".table-container"));
        self.delegateEvents();
      })
      .fail(
        ErrorUtils.errorHandler({
          activity: "loading the page",
        })
      );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/groups/Details.js
// module id = 930
// module chunks = 1